import { RoomStageInfo } from '../types';

export function parseStageDates(stages: RoomStageInfo[]): RoomStageInfo[] {
  return stages.map((stage) => {
    return {
      ...stage,
      startedAt: stage.startedAt ? new Date(stage.startedAt) : null,
      completedAt: stage.completedAt ? new Date(stage.completedAt) : null,
      puzzles: stage.puzzles.map((puzzle) => {
        return {
          ...puzzle,
          completedAt: puzzle.completedAt ? new Date(puzzle.completedAt) : null,
        };
      }),
    };
  });
}
